(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peggico-home-v3"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pg-v3').forEach((root) => {
    const slides = [...root.querySelectorAll('.pg-v3__slide')];
    const dots = [...root.querySelectorAll('[data-slide]')];
    const count = root.querySelector('[data-count]');
    let current = 0;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, item) => slide.classList.toggle('is-active', item === current));
      dots.forEach((dot, item) => dot.classList.toggle('is-active', item === current));
      count.textContent = `0${current + 1} / 03`;
    };
    root.querySelector('[data-prev]')?.addEventListener('click', () => show(current - 1));
    root.querySelector('[data-next]')?.addEventListener('click', () => show(current + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.slide))));

    const experienceTrack = root.querySelector('[data-experience-track]');
    const experienceCards = [...root.querySelectorAll('[data-experience-card]')];
    const experiencePrev = root.querySelector('[data-experience-prev]');
    const experienceNext = root.querySelector('[data-experience-next]');
    const experienceCount = root.querySelector('[data-experience-count]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let experienceIndex = 0;
    let experienceTimer;
    let scrollFrame;

    const updateExperienceCount = () => {
      if (experienceCount) experienceCount.textContent = `${String(experienceIndex + 1).padStart(2, '0')} / 10`;
    };
    const nearestExperienceIndex = () => experienceCards.reduce((nearest, card, index) => (
      Math.abs(card.offsetLeft - experienceTrack.scrollLeft) < Math.abs(experienceCards[nearest].offsetLeft - experienceTrack.scrollLeft) ? index : nearest
    ), 0);
    const showExperience = (index, behavior = 'smooth') => {
      if (!experienceTrack || !experienceCards.length) return;
      experienceIndex = (index + experienceCards.length) % experienceCards.length;
      experienceTrack.scrollTo({ left: experienceCards[experienceIndex].offsetLeft, behavior });
      updateExperienceCount();
    };
    const stopExperience = () => window.clearInterval(experienceTimer);
    const startExperience = () => {
      stopExperience();
      if (!reducedMotion.matches && experienceCards.length > 1) {
        experienceTimer = window.setInterval(() => showExperience(experienceIndex + 1), 5000);
      }
    };

    if (experienceTrack && experienceCards.length) {
      experiencePrev?.addEventListener('click', () => { stopExperience(); showExperience(experienceIndex - 1); startExperience(); });
      experienceNext?.addEventListener('click', () => { stopExperience(); showExperience(experienceIndex + 1); startExperience(); });
      experienceTrack.addEventListener('mouseenter', stopExperience);
      experienceTrack.addEventListener('mouseleave', startExperience);
      experienceTrack.addEventListener('focusin', stopExperience);
      experienceTrack.addEventListener('focusout', (event) => { if (!experienceTrack.contains(event.relatedTarget)) startExperience(); });
      experienceTrack.addEventListener('pointerdown', stopExperience);
      experienceTrack.addEventListener('pointerup', startExperience);
      experienceTrack.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          experienceIndex = nearestExperienceIndex();
          updateExperienceCount();
        });
      }, { passive: true });
      reducedMotion.addEventListener?.('change', startExperience);
      updateExperienceCount();
      startExperience();
    }

    const filters = [...root.querySelectorAll('[data-filter]')];
    const toys = [...root.querySelectorAll('[data-season]')];
    filters.forEach((filter) => filter.addEventListener('click', () => {
      filters.forEach((item) => item.classList.toggle('is-active', item === filter));
      toys.forEach((toy) => { toy.hidden = filter.dataset.filter !== 'all' && !toy.dataset.season.split(' ').includes(filter.dataset.filter); });
    }));
  });

  } catch(e) { console.error(e); }
})();
})();
